// extracted by mini-css-extract-plugin
module.exports = {"header":"items_list_header__3QYR1","item":"items_list_item__3Wn-k"};